import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GuideContentDesktop = styled(Typography)(() => ({
  fontSize: '32px',
  fontWeight: 400,
  color: 'black',
  textAlign: 'left',
}));
